<template>
    <div class="grey darken-4 full bg" v-bind:style="{'background-image' : 'url('+ $store.state.base_url + '/uploads/subscriptions/' + details.id + '/' + details.background +')'}">
        <img  height="60" alt="" class="fixed-image-top" :src="$store.state.base_url + '/uploads/subscriptions/' + details.id + '/' + details.logo">
        <v-speed-dial v-model="dialShare" 
            fixed right bottom direction="left" open-on-hover>
            <template v-slot:activator>
            <v-btn fab bottom large color="primary">
                <v-icon v-if="dialShare">mdi-close</v-icon>
                <v-icon v-else>mdi-share-variant</v-icon>
            </v-btn>
            </template>
            <v-btn dark fab bottom color="blue" large :href="`https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`" target="_blank">
                <v-icon>mdi-facebook</v-icon>
            </v-btn>
            <v-btn dark fab bottom color="green" large :href="`https://wa.me/?text=Checkout%20this%20page.%20${shareUrl}`" target="_blank">
                <v-icon>mdi-whatsapp</v-icon>
            </v-btn>
        </v-speed-dial>
        <v-card width="120" class="bottom-left" :to="{name : 'Testimonial', params : {code : details.event_code}}">
            <v-card-title class="text-caption">
                SCAN TO POST
            </v-card-title>
            <v-card-text>
                <img :src="details.qr_code" width="100%" alt="">
            </v-card-text>
        </v-card>
        <div class="pa-10">
            <masonry-wall :items="posts" :ssr-columns="1" :column-width="300" :gap="16">
                <template #default="{ item, index }">
                    <v-card
                        class="mx-auto"
                        :style="{'background-color' : item.background}"
                        max-width="800"
                        @click="viewDetails(item)"
                        shaped
                    >
                        <v-img
                            v-if="item.image"
                            :src="$store.state.base_url + '/uploads/posts/images/' + item.id + '/' + item.image"
                            max-height="500"
                            position="center"
                        ></v-img>
                        <v-card-text class="text-center pre-wrap" :style="{'color' : item.font_color}">
                            {{ item.message }}
                        </v-card-text>

                        <v-card-actions>
                            <v-list-item dense>
                                <v-list-item-avatar color="grey darken-4">
                                    <span class="text-h5 white--text">{{ item.name.substring(0, 1) }}</span>
                                </v-list-item-avatar>
                                <v-list-item-content>
                                    <v-list-item-subtitle :style="{'color' : item.font_color}">{{ item.name }}</v-list-item-subtitle>
                                    <v-list-item-subtitle v-if="details.show_timestamp == 1" :style="{'color' : item.font_color}">{{ item.created_at }}</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </v-card-actions>
                    </v-card>
                </template>
            </masonry-wall>
        </div>
        <v-dialog max-width="500" v-model="postModal" overlay-opacity="0.9">
            <v-card :style="{'background-color' : postDetails.background}">
                <div style="position: relative;">
                    <v-btn 
                        icon 
                        color="default" 
                        large
                        style="position: absolute; right: 10px; top: 10px; z-index: 999;"
                        @click="downloadImage(postDetails)">
                        <v-icon>mdi-download</v-icon>
                    </v-btn>
                    <v-img style="max-height: 600px;" :src="`${apiHost}/uploads/posts/images/${postDetails.id}/${postDetails.image}`" v-if="postDetails.image"></v-img>
                </div>
                <v-card-text class="text-center pre-wrap pt-3" :style="{'color' : postDetails.font_color}">
                    <span v-if="postDetails.image">{{ postDetails.message }}</span>
                    <h1 v-if="!postDetails.image" style="line-height: 3rem;">{{ postDetails.message }}</h1>
                </v-card-text>
                <v-card-actions>
                    <v-list-item class="grow">
                        <v-list-item-avatar color="grey darken-3">
                            <span class="text-h5 white--text">{{ postDetails.name?.substring(0, 1) }}</span>
                        </v-list-item-avatar>

                        <v-list-item-content>
                            <v-list-item-title :style="{'color' : postDetails.font_color}">{{ postDetails.name }}</v-list-item-title>
                            <v-list-item-subtitle v-if="postDetails.show_timestamp == 1" :style="{'color' : postDetails.font_color}">{{ postDetails.created_at }}</v-list-item-subtitle>
                        </v-list-item-content>

                        <v-row align="center" justify="end">
                            <v-btn dark :href="postDetails.qr_code" download="qrcode.png" target="_blank" fab small>
                                <v-icon>
                                    mdi-qrcode-scan
                                </v-icon>
                            </v-btn>
                        </v-row>
                    </v-list-item>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<style scoped>
    .back-border {
        opacity: .6;
        width: 100%;
        height: 15px;
        background: #000;
        position:fixed;
        top: 0px;
        z-index:9;
    }
    .fixed-image-top {
        position: fixed;
        z-index: 10;
        right : 15px;
        top: 15px;
    }
    .full {
        width: 100%;
        height : 100%;
    }
    .bg {
        background-size:cover;
        background-repeat: no-repeat;
        background-color: #fff;
        background-position: top;
        background-attachment: fixed;
    }
    .pre-wrap {
        white-space: pre-wrap; 
    }
    .bottom-left {
        position: fixed;
        bottom : 10px;
        left : 10px;
        z-index: 999999;
    }
</style>
<script>
import axios from 'axios'
import Pusher from '@/plugins/pusher.js'
export default {
    name : 'SlideShowView',
    data () {
        return {
            apiHost : process.env.VUE_APP_BASE_URL,
            posts: [],
            timer : null,
            details : {},
            metaTags : {},
            shareUrl : null,
            interval : 180000,
            dialShare : null,
            postModal : false,
            postDetails : {}
        }
    },
    mounted() {
        Pusher.logToConsole = false;

        var pusher = new Pusher('f69685e43c93fed4d15c', {
            cluster: 'ap1'
        });

        var channel = pusher.subscribe('my-channel');
        channel.bind('my-event', data => {
            if(data.code == this.details.event_code) {
                console.log(data);
                if(data.type == 'approve') {
                    var posts = this.posts;
                    posts.unshift(data);
                    this.posts = JSON.parse(JSON.stringify(posts));

                    clearInterval(this.timer);

                    this.timer = setInterval(()=>{
                        this.refresh(1);
                        console.log('refreshed');
                    }, this.interval);
                }
                else if(data.type == 'remove') {
                    this.refresh(0);
                }
            }
        });

        this.getEventDetails();
    },
    destroyed() {
        clearInterval(this.timer)
    },
    methods : {
        getEventDetails() {
            axios({
                url : this.$store.state.api_url + '/event-details/' + this.$route.params.code,
                method : 'GET',
            }).then(res => {
                this.details = res.data;
                this.shareUrl = 'https://livesocialfeed.com/events/' + this.details.key
                this.interval = (this.details.rotation_interval * 60) * 1000;

                this.timer = setInterval(()=>{
                    this.refresh(1);
                    console.log('refreshed');
                }, this.interval);
                this.refresh();
            });
        },
        refresh(randomized = 0) {
            axios({
                url : this.$store.state.api_url + '/posts/' + this.$route.params.code,
                method : 'GET',
                params : {randomized : randomized, approved : 1}
            }).then(res => {
                this.posts = res.data;
            });
        },
        viewDetails(post) {
            console.log(post);
            this.postDetails = post;
            this.postModal = true;
        },
        async downloadImage(post) {
            const imageLink = `${this.apiHost}/uploads/posts/images/${post.id}/${post.image}`
            
            window.open(imageLink, '_blank');
        }
    }
}
</script>